/**
 * Scroll-container-aware helpers for the storefront (PD-14694/PD-14672
 * follow-up).
 *
 * The storefront's scroll offset does NOT live in one place across
 * platforms. `index.css` gives `body { overflow: auto }`:
 *
 *  - On desktop/Android browsers, `html`'s overflow is `visible`, so per
 *    the CSS spec the body's overflow value propagates to the VIEWPORT —
 *    the window scrolls, and `window.scrollY` / `window.scrollTo` work.
 *  - On iOS/WKWebView (the Capacitor app), the
 *    `@supports (-webkit-touch-callout: none)` block pins
 *    `html { overflow: hidden }`, which stops that propagation. `body`
 *    becomes a real element scroller: the offset lives on
 *    `document.body.scrollTop`, `window.scrollY` is stuck at 0, and
 *    `window.scrollTo` is a no-op.
 *
 * PullToRefresh and ScrollToTop originally shipped against the
 * window-only model and silently broke in the native app (pull-to-refresh
 * armed from mid-page; scroll reset on navigation did nothing). Always
 * read/write scroll through these helpers, never `window.scrollY` /
 * `window.scrollTo` directly.
 */

/** The storefront's current vertical scroll offset, whichever element owns it. */
export function getAppScrollTop(): number {
	return Math.max(
		window.scrollY,
		document.documentElement.scrollTop,
		document.body.scrollTop,
	);
}

/** Scroll the storefront to the top — covers both scroll-container modes. */
export function appScrollToTop(behavior: ScrollBehavior = 'auto'): void {
	window.scrollTo({ top: 0, left: 0, behavior });
	// Element-scroller mode (iOS WKWebView): the window call above doesn't
	// touch body's own offset. A no-op when the window is the scroller.
	document.body.scrollTo({ top: 0, left: 0, behavior });
}
